"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

/**
 * Locale Icon Component
 *
 * Tree-shakeable icon component for locale/language indicators.
 *
 * @example
 * ```tsx
 * import Locale from '@insided/destination/icons/Locale'
 *
 * <Locale width={16} height={16} />
 * ```
 */
var Locale = function Locale(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Locale",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M12.2 21.6L16.475 10.2H18.525L22.8 21.6H20.825L19.8 18.675H15.2L14.175 21.6H12.2ZM4.225 18.6L2.975 17.325L7.775 12.575C7.175 11.9417 6.61667 11.2833 6.1 10.6C5.58333 9.91666 5.13333 9.17499 4.75 8.37499H6.8C7.1 8.90833 7.4 9.36249 7.7 9.73749C8 10.1125 8.43333 10.6167 9 11.25C9.63333 10.55 10.2167 9.82083 10.75 9.06249C11.2833 8.30416 11.7167 7.48333 12.05 6.59999H1.2V4.79999H8.1V2.39999H9.9V4.79999H16.8V6.59999H13.95C13.6 7.74999 13.0917 8.81249 12.425 9.78749C11.7583 10.7625 11.025 11.6917 10.225 12.575L12.5 14.825L11.8 16.675L9 13.875L4.225 18.6ZM15.8 17.025H19.2L17.55 12.3L15.8 17.025Z",
    fill: "currentColor"
  }));
};

var _default = Locale;
exports.default = _default;